var constants = require('../constants');
var cloneDeep = require('lodash/cloneDeep');

var surveyStateHistoryActions = (function() {

    var _cacheSurveyState = function() {
        return function(dispatch, getState) {
            var state = getState();
            dispatch({
                type: constants.CACHE_SURVEY_STATE,
                surveySate: {
                    surveys: cloneDeep(state.surveys),
                    entities: cloneDeep(state.entities),
                    responses: cloneDeep(state.responses)
                }
            });
        };
    }

    var _goPreviousSurveyState = function() {
        return function(dispatch, getState) {
            var state = getState();
            var surveyStateHistory = state.surveyStateHistory.data;
            var previousSurveyState = surveyStateHistory[surveyStateHistory.length - 1];
            dispatch({
                type: constants.GO_PREVIOUS_SURVEY_STATE,
                previousSurveyState: previousSurveyState || {}
            });
        };
    }

    return {
        cacheSurveyState: _cacheSurveyState,
        goPreviousSurveyState: _goPreviousSurveyState
    }
})();

module.exports = surveyStateHistoryActions;



// WEBPACK FOOTER //
// ./src/common/modules/surveyStateHistory/actions/surveyStateHistory.js